import { useEffect } from 'react';
import { useEventsApi } from './useEventsApi';

interface UseEventListProps {
  itemsPerPage?: number;
  startDate?: Date | null;
  endDate?: Date | null;
}

const useEventList = ({ itemsPerPage = 10, startDate, endDate }: UseEventListProps = {}) => {
  const { currentPage, eventsData, onPageChange, onDeleteEvent, fetchEvents } = useEventsApi({
    itemsPerPage,
    startDate,
    endDate,
  });

  useEffect(() => {
    fetchEvents();
  }, [currentPage, startDate, endDate, fetchEvents]);

  return {
    currentPage,
    eventsData,
    onPageChange,
    onDeleteEvent,
    fetchEvents,
  };
};

export default useEventList;
